module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-15.4850c767.png";